import { render, staticRenderFns } from "./CreateAndUpdateUser.vue?vue&type=template&id=b1daffba&scoped=true&"
import script from "./CreateAndUpdateUser.vue?vue&type=script&lang=js&"
export * from "./CreateAndUpdateUser.vue?vue&type=script&lang=js&"
import style0 from "./CreateAndUpdateUser.vue?vue&type=style&index=0&id=b1daffba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1daffba",
  null
  
)

export default component.exports